import type { ReactNode } from 'react';

interface InfoModalProps {
  visible: boolean;
  title: string;
  content: string;
  onClose: () => void;
  children?: ReactNode;
}

export function InfoModal({ visible, title, content, onClose }: InfoModalProps) {
  if (!visible) return null;

  return (
    <div
      className="animate-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-6 backdrop-blur-lg"
      role="dialog"
      aria-modal="true"
      aria-labelledby="info-modal-title"
    >
      <div
        className="animate-modal-content w-full max-w-md rounded-3xl bg-white/90 p-6 shadow-xl backdrop-blur-lg"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="info-modal-title" className="mb-3 text-lg font-bold text-primary">
          {title}
        </h2>
        <p className="mb-5 text-[15px] leading-relaxed text-text-heading">{content}</p>
        <button
          type="button"
          onClick={onClose}
          className="w-full rounded-xl bg-primary py-3 text-base font-bold text-white transition hover:bg-primary-active active:bg-primary-active"
        >
          Tamam
        </button>
      </div>
      <button
        type="button"
        className="absolute inset-0 -z-10"
        aria-label="Kapat"
        onClick={onClose}
      />
    </div>
  );
}
